import React, { useState } from 'react';
import { NumericFormat } from 'react-number-format';

export const InputNumber = React.forwardRef(
  (
    {
      id,
      type = 'number',
      name,
      label,
      className,
      onFocus,
      onBlur,
      autoFocus,
      onChange,
      onClick,
      value,
      placeholder = ' ',
      readOnly,
      max,
    },
    ref
  ) => {
    const [isActive, setIsActive] = useState(false);

    return (
      <div
        className={`outline relative border border-black focus-within:border-blue1 focus-within:text-blue1 rounded-3 ${className}`}
      >
        <NumericFormat
          getInputRef={ref}
          prefix="Rp. "
          thousandSeparator="."
          decimalSeparator=","
          onFocus={() => setIsActive(true)}
          onBlur={() => setIsActive(false)}
          className={`block p-3 w-full text-sm font-inter appearance-none border-none focus:outline-none  rounded-3 text-black2 ${
            isActive
              ? 'placeholder-gray1'
              : 'relative z-10 bg-transparent placeholder-transparent'
          }`}
          value={value}
          placeholder={placeholder}
          allowNegative={false}
          onValueChange={onChange}
          isAllowed={(values) => {
            const { floatValue } = values;
            if (max) {
              return floatValue <= max;
            }
            return values;
          }}
        />
        <label
          htmlFor="username"
          className={`absolute top-0 text-sm font-inter bg-white p-3 duration-300 origin-0 rounded-full break-words ${
            isActive ? 'z-40 focus-within:text-blue-600' : '-z-1 text-gray1'
          }`}
        >
          {label || placeholder}
        </label>
      </div>
    );
  }
);
